import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export const COLOR_CLASS_NAMES = {
    "text-primary": "text-text-primary dark:text-text-primary-darkmode",
    "text-primary-inverse": "text-text-primary-inverse dark:text-text-primary-inverse-darkmode",
    "text-subdued": "text-text-subdued dark:text-text-subdued-darkmode",
    "text-disabled": "text-text-disabled dark:text-text-disabled-darkmode",
    "text-critical": "text-text-critical dark:text-text-critical-darkmode",
    "text-success": "text-text-success dark:text-text-success-darkmode ",
    "text-link": "text-cta-primary-default dark:text-text-link-darkmode",
    "text-primary-darkmode": "text-text-primary-darkmode",
    "text-primary-inverse-darkmode": "text-text-primary-inverse-darkmode",
    "text-subdued-darkmode": "text-text-subdued-darkmode",
    "text-disabled-darkmode": "text-text-disabled-darkmode",
    "text-critical-darkmode": "text-text-critical-darkmode",
    "text-success-darkmode": "text-text-success-darkmode",
    "text-link-darkmode": "text-text-link-darkmode",
};
const variants = {
    "body-extra-small": {
        tagName: "div",
        classNames: "font-body-extra-small",
    },
    "body-large-emphasis": {
        tagName: "div",
        classNames: "font-body-large-emphasis",
    },
    "body-large": {
        tagName: "div",
        classNames: "font-body-large",
    },
    "body-medium-emphasis": {
        tagName: "div",
        classNames: "font-body-medium-emphasis",
    },
    "body-medium": {
        tagName: "div",
        classNames: "font-body-medium",
    },
    "body-small-emphasis": {
        tagName: "div",
        classNames: "font-body-small-emphasis",
    },
    "body-small": {
        tagName: "div",
        classNames: "font-body-small",
    },
    display: {
        tagName: "h1",
        classNames: "font-display",
    },
    "headline-de-emphasis": {
        tagName: "h1",
        classNames: "font-headline-de-emphasis",
    },
    headline: {
        tagName: "h1",
        classNames: "font-headline",
    },
    "subtitle-de-emphasis": {
        tagName: "h3",
        classNames: "font-subtitle-de-emphasis",
    },
    subtitle: {
        tagName: "h3",
        classNames: "font-subtitle",
    },
    "title-de-emphasis": {
        tagName: "h2",
        classNames: "font-title-de-emphasis",
    },
    title: {
        tagName: "h2",
        classNames: "font-title",
    },
};
export const Typography = ({ variant = "body-medium", children, color, className = "", }) => {
    const variantData = variants[variant];
    const computedClassName = classNames(variantData.classNames, className, color && COLOR_CLASS_NAMES[color]);
    const HTMLTag = variantData.tagName;
    return _jsx(HTMLTag, { className: computedClassName, children: children });
};
//# sourceMappingURL=Typography.js.map